module.exports = __webpack_public_path__ + "static/media/dailekh1.05fb83a2.ogg";